import {
  alpha,
  Avatar,
  Badge,
  Box,
  Button,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Paper,
  Popover,
  useTheme,
  Tooltip,
  Typography,
  styled,
  LinearProgress
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import NotificationsActiveTwoToneIcon from '@mui/icons-material/NotificationsActiveTwoTone';
import Link from '@mui/material/Link';
import DescriptionTwoToneIcon from '@mui/icons-material/DescriptionTwoTone';
import CommentTwoToneIcon from '@mui/icons-material/CommentTwoTone';
import { useTranslation } from 'react-i18next';
import { formatDistance, subHours, subSeconds, subDays, parse } from 'date-fns';
import React from 'react';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';
import { Client, MessageDto } from '../../../../DashboardApi/api';
import InfoIcon from '@mui/icons-material/Info';
import WarningIcon from '@mui/icons-material/Warning';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useNotifications } from '../../../../contexts/notificationsContext';
import { useBreadcrumbs } from '../../../../contexts/BreadCrumbsContext'
import { REACT_APP_PORTAL_API_URL } from '../../../../../KeyVariables';
import { ro } from 'date-fns/locale';
const NotificationsBadge = styled(Badge)(
  ({ theme }) => `
    
    .MuiBadge-badge {
        background-color: ${theme.palette.error.main};
        color: ${theme.palette.error.contrastText};
        min-width: 18px; 
        height: 18px;
        padding: 0;

        &::after {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            border-radius: 50%;
            box-shadow: 0 0 0 1px ${alpha(theme.palette.error.main, 0.3)};
            content: "";
        }
    }
`
);

const IconButtonPrimary = styled(IconButton)(
  ({ theme }) => `
    margin-left: ${theme.spacing(1)};
    background: ${theme.colors.alpha.trueWhite[10]};
    color: ${theme.colors.alpha.trueWhite[70]};
    padding: 0;
    width: 42px;
    height: 42px;
    border-radius: 100%;
    transition: ${theme.transitions.create(['background', 'color'])};

    &.active,
    &:active,
    &:hover {
      background: ${alpha(theme.colors.alpha.trueWhite[30], 0.2)};
      color: ${theme.colors.alpha.trueWhite[100]};
    }
`
);


function HeaderNotifications() {
  const ref = useRef<any>(null);
  const [isOpen, setOpen] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const theme = useTheme();
  // const [notifications, setNotifications] = useState<MessageDto[]>([]);
  const { notifications, notificationsCount, addNotification, removeAll, removeById } = useNotifications();

  const apiUrl = REACT_APP_PORTAL_API_URL;
  const client = new Client(apiUrl);

  const iconMap = {
    Info: <InfoIcon />,
    Warning: <WarningIcon />,
    Error: <ErrorIcon />,
    Success: <CheckCircleIcon />,
  };


  const colorsMap = {
    Info: theme.colors.info.main,
    Warning: theme.colors.warning.main,
    Error: theme.colors.error.main,
    Success: theme.colors.success.main,
  };

  const markAllAsRead = (): void => {
    client.dismissallnotify();
    removeAll();
  };

  const loadMore = (): void => {
    client.getnotifications(page + 1).then(data => {
      if (data.length > 0) {
        addNotification(data, true)
      }
    });
    setPage(page + 1);
  };

  const markAsRead = (id: number): void => {
    client.dismissnotify(id);
    removeById(id)
  };


  const createMarkup = (htmlString) => {
    return { __html: htmlString };
  };

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  const { t }: { t: any } = useTranslation();
  const [loadingPrint, setLoadingPrint] = useState(false);
  const handleDocPrint = (documentId) => {
    try {
      setLoadingPrint(true);
      // handlePrintClick(documentId)
    }
    catch (ex) {
      console.error(ex);
    }
    finally {
      setLoadingPrint(false);
    }
  }

  return (
    <>
      <Tooltip arrow title={t('Notifications')}>
        <IconButtonPrimary color="primary" ref={ref} onClick={handleOpen}>
          <NotificationsBadge
            badgeContent={notificationsCount}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
          >
            <NotificationsActiveTwoToneIcon />
          </NotificationsBadge>
        </IconButtonPrimary>
      </Tooltip>
      <Popover
        disableScrollLock
        anchorEl={ref.current}
        onClose={handleClose}
        open={isOpen}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          sx: {
            minWidth: 400,
            maxHeight: 600,
            overflowY: 'auto'
          }
        }}

      >
        <Box
          sx={{
            p: 2,
          }}
          display="flex"
          justifyContent="space-between"
        >
          <Typography variant="h5">{t('Notifications')}</Typography>
          {
            notifications.length > 0 ? (
              <Link
                href="#"
                variant="caption"
                sx={{
                  textTransform: 'none'
                }}
                onClick={markAllAsRead}
              >
                {t('Mark all as read')}
              </Link>
            ) : null
          }
        </Box>
        <Divider />
        <List
          sx={{
            p: 0
          }}
        >
          {
            notifications.length > 0 ?

              notifications.map(notif => (
                <>
                  <ListItem
                    sx={{
                      display: { xs: 'block', sm: 'flex' }
                    }}
                  >
                    <ListItemAvatar>

                      <Avatar
                        sx={{
                          background: colorsMap[notif.type!]
                        }}
                      >
                        {iconMap[notif.type!]}

                      </Avatar>

                    </ListItemAvatar>
                    <Box flex={1}>
                      <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography
                          sx={{
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center'
                          }}
                        >
                          {/* <span>{notif.component}: </span> */}
                          {notif.subject}
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            textTransform: 'none'
                          }}
                        >
                          {/* {formatDistance(parse(notif.dateTime!, 'HH:mm dd.MM.yyyy', new Date()), new Date(), {
                            addSuffix: true,
                            locale: ro,
                          })} */}
                          <IconButton onClick={() => markAsRead(notif.id!)}>
                            <CloseIcon />
                          </IconButton>
                        </Typography>
                      </Box>
                      <Typography
                        component="span"
                        variant="body2"
                        color="text.secondary"
                        dangerouslySetInnerHTML={createMarkup(notif.body)}
                      />
                      {
                        notif.documentId && (
                          <Link
                            href="#"
                            onClick={(e) => {
                              e.preventDefault(); // Отключить переход по ссылке
                              handleDocPrint(notif.documentId);
                            }}
                            sx={{
                              fontSize: 14,
                              ml: 1,
                              textDecoration: 'underline', // Подчеркнуто как у <a>
                              color: 'inherit', // Цвет по умолчанию (как у <a>)
                              '&:hover': {
                                textDecoration: 'underline', // Сохраняем подсветку при наведении
                                color: 'blue', // Цвет при наведении (можно настроить)
                              },
                              '&:visited': {
                                color: 'purple', // Цвет посещенной ссылки (как у стандартного <a>)
                              },
                            }}
                          >
                            Document
                          </Link>
                        )
                      }

                    </Box>


                  </ListItem>
                  {loadingPrint && <LinearProgress />}
                  <Divider
                    variant="inset"
                    sx={{
                      my: 1
                    }}
                    component="li"
                  />
                </>
              )) : <>
                <Typography
                  sx={{ p: 1 }}
                >
                  There is no notifications missed!
                </Typography>

              </>
          }

        </List>
        <Divider />
        <Divider />
        <Box m={1}>
          <Button color="secondary" fullWidth onClick={loadMore}>
            {t('Load more')}
          </Button>
        </Box>
      </Popover>
    </>
  );
}

export default HeaderNotifications;
